export const UserModule = {
    namespaced: true,
    state: {
        accessToken: "",
        _id: null,
        userInfo: {},
        teamList: [],
        tableLoader: 1,
        totalRecord: 0,
        totalLenght: 0,
    }
}